import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import React from "react";
import { useIntl } from "react-intl";

import { fieldSx } from "./questionTypes/optionSx";

type Props = {
    value: string | undefined;
    onChange: (value: string | undefined) => void;
    error?: boolean;
    label?: string;
};

export const DateField: React.FC<Props> = ({ value, onChange, error, label }) => {
    const { formatMessage } = useIntl();
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                format="DD MMM YYYY"
                label={label}
                value={value ? dayjs(value) : null}
                onChange={(next) => {
                    if (next?.isValid() === false) return;
                    onChange(next ? next.format("YYYY-MM-DD") : undefined);
                }}
                slotProps={{
                    textField: {
                        size: "small",
                        error,
                        placeholder: formatMessage({ defaultMessage: "Select date" }),
                    },
                }}
                sx={fieldSx}
            />
        </LocalizationProvider>
    );
};
